"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.delayValueMap = exports.default = exports.Tooltip = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeHelper = require("../Utilities/ThemeHelper");

var _excluded = ["className", "delay", "PopperProps"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var useStyles = (0, _ThemeHelper.makeStyles)(function (theme) {
  return {
    popper: {
      top: 0,
      // These position styles are needed to fix an overflow issue when a button with a tooltip triggers a popover.
      left: 0 // The inline positioning on the popper should override these values.

    }
  };
});
var delayValueMap = {
  instant: 0,
  short: 240,
  long: 960
};
exports.delayValueMap = delayValueMap;

var Tooltip = function Tooltip(props) {
  var className = props.className,
      _props$delay = props.delay,
      delay = _props$delay === void 0 ? "short" : _props$delay,
      PopperProps = props.PopperProps,
      otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classes = useStyles(props);
  var leaveDelay = delayValueMap[delay];
  var enterDelay = leaveDelay;
  var modifiers = PopperProps === null || PopperProps === void 0 ? void 0 : PopperProps.modifiers;

  var renderedPopperProps = _objectSpread(_objectSpread({}, PopperProps), {}, {
    modifiers: _objectSpread(_objectSpread({}, modifiers), {}, {
      flip: _objectSpread({
        enabled: true
      }, modifiers === null || modifiers === void 0 ? void 0 : modifiers.flip),
      preventOverflow: _objectSpread({
        enabled: true,
        boundariesElement: "scrollParent"
      }, modifiers === null || modifiers === void 0 ? void 0 : modifiers.preventOverflow)
    })
  });

  return /*#__PURE__*/_react.default.createElement(_Tooltip.default, (0, _extends2.default)({
    leaveDelay: leaveDelay,
    enterDelay: enterDelay
  }, otherProps, {
    PopperProps: renderedPopperProps,
    classes: _objectSpread(_objectSpread({}, classes), {}, {
      popper: (0, _classnames.default)("prmbl-tooltip", className, classes.popper)
    })
  }));
};

exports.Tooltip = Tooltip;
Tooltip.defaultProps = {
  delay: "short",
  placement: "top"
};
var _default = Tooltip;
exports.default = _default;